import { GetOfferRequestPaymentDetailsForAdminState } from './getOfferRequestPaymentDetailsForAdmin.types'

const initialState: GetOfferRequestPaymentDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
